import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { styled } from "@mui/material/styles";
import { GridProps, InternalStandardProps } from "@mui/material";
import { AppCircularProgress } from "../Progress/AppCircularProgress";
import downloadDisabled from "Images/Content/download-disabled.png";
import downloadDisabledDark from "Images/Content/download-disabled-dark.png";

import { AppDownloadingIcons } from "./AppDownloadingIcons";
import { useThemeModeContext } from "JS/React/Context/ThemeModeProvider";

const StyledIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.palette.grey[600],
    fontSize: "22px",
}));

const SecondaryIcon = styled(StyledIcon)({
    marginTop: "15px",
});

export const DownloadStatusIcon = (props: DownloadStatusIconProps) => {
    const themeModeContext = useThemeModeContext();

    const { downloadStatus, isCourse, sizesLoading, isSizeValid } = props;

    if (downloadStatus === "downloaded") {
        return isCourse ? (
            <AppDownloadingIcons iconType="trash" />
        ) : (
            <SecondaryIcon icon={["far", "floppy-disk"]} />
        );
    }

    if (downloadStatus === "in-progress") {
        return (
            <AppDownloadingIcons iconType="in-progress" addMargin={!isCourse} />
        );
    }

    if (downloadStatus === "queued") {
        return <AppDownloadingIcons iconType="queued" addMargin={!isCourse} />;
    }

    if (isCourse) {
        return sizesLoading ? (
            <AppCircularProgress loaderSize="small" />
        ) : isSizeValid ? (
            <AppDownloadingIcons iconType="download" />
        ) : (
            <img
                src={
                    themeModeContext.mode === "light"
                        ? downloadDisabled
                        : downloadDisabledDark
                }
                style={{
                    height: "26px",
                }}
                alt="download-disabled"
            />
        );
    }

    return <></>;
};

interface DownloadStatusIconProps extends InternalStandardProps<GridProps> {
    downloadStatus?: StepListDownloadType;
    isCourse?: boolean;
    sizesLoading?: boolean;
    isSizeValid?: boolean;
}

export type StepListDownloadType = "in-progress" | "queued" | "downloaded";
